import { WifiOffIcon, DownloadIcon, SmartphoneIcon } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface PwaBenefit {
  title: string
  desc: string
  image: string
  imageAlt: string
  icon: LucideIcon
  iconBg: string
  iconColor: string
}

export const pwaBenefits: PwaBenefit[] = [
  {
    title: 'Funguje offline',
    desc: 'Appka beží aj bez internetu. Dáta sa synchronizujú po pripojení.',
    image: 'https://images.unsplash.com/photo-1526498460520-4c246339dccb?w=600&h=300&fit=crop&crop=center',
    imageAlt: 'Smartfón v ruke používateľa',
    icon: WifiOffIcon,
    iconBg: 'bg-blue-50',
    iconColor: 'text-apple-blue',
  },
  {
    title: 'Inštalácia jedným klikom',
    desc: 'Žiadny App Store ani schvaľovanie. Jeden klik a appka je na ploche.',
    image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=600&h=300&fit=crop&crop=center',
    imageAlt: 'Mobilná aplikácia na obrazovke telefónu',
    icon: DownloadIcon,
    iconBg: 'bg-purple-50',
    iconColor: 'text-purple-600',
  },
  {
    title: 'Natívny výkon',
    desc: 'Push notifikácie, kamera, GPS aj NFC — ako v natívnych appkách.',
    image: 'https://images.unsplash.com/photo-1551650975-87deedd944c3?w=600&h=300&fit=crop&crop=center',
    imageAlt: 'Viacero mobilných zariadení s aplikáciou',
    icon: SmartphoneIcon,
    iconBg: 'bg-emerald-50',
    iconColor: 'text-emerald-600',
  },
]
